<div class="body-padding-start-window">
  <div class="form-container">
    <div class="special-font font-bold text-xl pb-1">You have been unsubscribed.</div>
    <div class="text-md text-gray-600 pb-1">You will not receive any further emails from us.</div>
    <div class="text-md text-gray-600">
      Unsubscribed by mistake? Please contact ReNew Biomedical Services for assistance.
    </div>
  </div>
</div>
